const lockPortrait = () => {
  const orientation = window.screen && window.screen.orientation;
  if (orientation && orientation.lock) {
    return orientation.lock("portrait");
  }
};

export { lockPortrait };
